/**
 * 表格加載動畫組件
 * 統一的三點跳動加載效果
 */
export default function TableLoading({ colSpan = 5, message = "正在加載..." }: { colSpan?: number; message?: string }) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-6 py-12 text-center">
        <div className="flex items-center justify-center gap-2">
          <div className="h-2 w-2 rounded-full bg-blue-600 animate-bounce" style={{ animationDelay: '0s' }} />
          <div className="h-2 w-2 rounded-full bg-blue-600 animate-bounce" style={{ animationDelay: '0.2s' }} />
          <div className="h-2 w-2 rounded-full bg-blue-600 animate-bounce" style={{ animationDelay: '0.4s' }} />
        </div>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          {message}
        </p>
      </td>
    </tr>
  )
}
